import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDeviceModeStore } from '../store/deviceModeStore.js';
import { usarPlan } from '../lib/plan.js';
import styles from './HubSetupScreen.module.css';

// La primera vez que un restaurante entra en un aparato, se pregunta para qué
// sirve. Antes se adivinaba por el ancho de la pantalla y nunca se preguntaba:
// una tablet que arrancaba en vertical quedaba como comandera —sin cobrar, sin
// salida del plano de mesas— y un celular que arrancaba acostado quedaba como
// caja pidiendo efectivo inicial. La suposición sigue, pero solo como opción
// marcada de entrada.
export default function ModoAparatoScreen() {
  const navigate      = useNavigate();
  const { cocina }    = usarPlan();
  const modoGuardado  = useDeviceModeStore((s) => s.modo);
  const compartidaYa  = useDeviceModeStore((s) => s.compartida);
  const setModo       = useDeviceModeStore((s) => s.setModo);
  const setCompartida = useDeviceModeStore((s) => s.setCompartida);
  const [modo, setModoLocal]   = useState(modoGuardado);
  const [compartida, setComp]  = useState(compartidaYa);

  const continuar = () => {
    setModo(modo);
    setCompartida(compartida);
    navigate(modo === 'comandera' ? '/tables' : '/', { replace: true });
  };

  const opciones = [
    { v: 'caja', t: 'Caja', d: 'Cobra, abre y cierra el turno. La tablet del mostrador.' },
    { v: 'comandera', t: 'Comandera', d: cocina
      ? 'Toma las órdenes en las mesas y las manda a cocina. La caja cobra.'
      : 'Toma las órdenes en las mesas. La caja cobra.' },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <h1 className={styles.title} style={{ marginBottom: 6 }}>¿Para qué es este aparato?</h1>
        <p className={styles.lead}>
          Se pregunta una sola vez. Si te equivocas, se cambia en el menú ⋯ › Este aparato.
        </p>

        <div className={styles.modos}>
          {opciones.map(({ v, t, d }) => (
            <button
              key={v}
              type="button"
              className={`${styles.modo} ${modo === v ? styles.modoActivo : ''}`}
              aria-pressed={modo === v}
              onClick={() => setModoLocal(v)}
            >
              <strong>{t}</strong>
              <small>{d}</small>
            </button>
          ))}
        </div>

        <label className={styles.check} style={{ marginTop: 6 }}>
          <input type="checkbox" checked={compartida} onChange={(e) => setComp(e.target.checked)} />
          <span>
            <strong>La usan varios meseros</strong>
            <small>Cada quien se identifica con su PIN al tomar una mesa.</small>
          </span>
        </label>

        <button type="button" className="btn btn--primary btn--full" onClick={continuar}>
          Continuar
        </button>
      </div>
    </div>
  );
}
